import { render, staticRenderFns } from "./top-newpage.vue?vue&type=template&id=12a09071"
import script from "./top-newpage.vue?vue&type=script&lang=js"
export * from "./top-newpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports